// ── Generate Invoice Request/Response ─────────────────────────────────

export interface CreateInvoiceRequest {
  facilityId: string; // required, GUID
  weekStartDate: string; // required, DateOnly ISO string
  weekEndDate: string; // required, DateOnly ISO string
}

export interface GeneratedInvoice {
  id: string;
  invoiceNumber: string;
  invoiceYear: number;
  invoiceSequenceNumber: number;
  facilityId: string;
  facilityName: string;
  weekStartDate: string;
  weekEndDate: string;
  subtotal: number;
  taxAmount: number;
  feeAmount: number;
  totalAmount: number;
  status: string;
  dueDate: string;
  generatedAt: string | null;
  sentAt: string | null;
  paidAt: string | null;
  paymentReference: string | null;
  hasAutoApprovedTimesheets: boolean;
  hasAdjustments: boolean;
  adjustmentSubtotal: number;
  differentialSubtotal: number;
  contractorPayTotal: number;
  huroMarginTotal: number;
  lineItems: InvoiceLineItem[];
}

export interface InvoiceLineItem {
  id: string;
  contractorId: string;
  contractorName: string;
  scopeOfPractice: string;
  shiftDate: string;
  hoursWorked: number;
  hourlyRate: number;
  lineTotal: number;
  isAdjustment: boolean;
  adjustmentType: string | null;
  originalPeriodStart: string | null;
  originalPeriodEnd: string | null;
  contractorHourlyRate: number | null;
  differentialRate: number | null;
  isDifferential: boolean;
  parentLineItemId: string | null;
}
